<span class="p-input-icon-left p-input-icon-right w-100 d-flex">
  <i class="pi pi-search" aria-hidden="true"></i>
  <input type="text" class="flex-grow-1 w-100" pInputText [formControl]="searchControl" [placeholder]="placeholder | translate"
         [attr.aria-label]="'allDocuments.filters.search.ariaLabel' | translate">
  <i *ngIf="searchControl.value" class="pi pi-times clear-icon" (click)="clearSearch()" 
     [attr.aria-label]="'allDocuments.filters.search.clearAriaLabel' | translate"></i>
</span>
